import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import cx from 'classnames';
import { getAudioFileUrl } from '@culture/utils/helpers/files';
import { getImageUrl } from '@culture/common-helpers/cultureUtils';

import { MaterialPropType, ThumbnailFilePropType } from 'propTypes/common';

import AudioPlayer from 'components/Audio/AudioPlayer';
import Icon from 'components/Icon';
import Modal from 'components/Modal';
import StyledContentImage from 'components/StyledContent/components/StyledContentImage';
import StyledContentVideo from 'components/StyledContent/components/StyledContentVideo';

import { useToggle } from 'hooks/useToogle';

import { ImageFormatContext } from 'contexts/ImageFormatContext';

import { getPreviewUrl } from 'utils/helpers/files';

import styles from './styles.module.scss';

const { publicRuntimeConfig } = getConfig();

const MatchingCardContent = ({ audio, image, text, typeCard, video }) => {
	const [isModalOpened, openModal, closeModal] = useToggle(false);
	const imageFormat = useContext(ImageFormatContext);

	const showModalVideo = () => {
		openModal();
	};

	const handleCloseModal = () => {
		closeModal();
	};

	// eslint-disable-next-line no-nested-ternary
	const imageSrc = image
		? typeof image === 'string'
			? image
			: getImageUrl(image, {
					format: imageFormat,
					params: {
						crop: 'fill',
						gravity: 'center',
						width: 200,
						height: 200
					}
			  })
		: null;

	// eslint-disable-next-line no-nested-ternary
	const trackUrl = !_.isEmpty(audio)
		? typeof audio === 'string'
			? audio
			: getAudioFileUrl(audio, {
					config: publicRuntimeConfig
			  })
		: null;

	const getMediaType = () => {
		if (audio) {
			return `${typeCard}Audio`;
		}

		if (image) {
			return `${typeCard}Image`;
		}

		if (video) {
			return `${typeCard}Video`;
		}

		return `${typeCard}Text`;
	};

	const mediaType = getMediaType();

	const previewVideo =
		!!video && video.file?.previews?.length
			? getPreviewUrl(video.file.previews[0])
			: null;

	const stylesCard = previewVideo
		? {
				backgroundColor: '#ece5d6',
				backgroundImage: `url("${previewVideo}")`
		  }
		: null;

	return (
		<div
			className={cx(
				styles.MatchingCardContent,
				mediaType && styles[`MatchingCardContent_media_${mediaType}`],
				typeCard === 'drag' && styles.MatchingCardContent_isDrag
			)}
			style={stylesCard}
		>
			<div className={styles.MatchingCardContent__Content}>
				{!!text && (
					<div className={styles.MatchingCardContent__Text}>{text}</div>
				)}
				{!!image && (
					<StyledContentImage
						src={imageSrc}
						className={styles.MatchingCardContent__Image}
						lazy={false}
					/>
				)}
				{!!trackUrl && (
					<div
						className={styles.MatchingCardContent__Audio}
						title="Воспроизвести аудио"
					>
						<AudioPlayer trackSrc={trackUrl} theme="simpleButton" />
					</div>
				)}
				{!!video && (
					<div className={styles.MatchingCardContent__Video}>
						<button
							type="button"
							className={styles.MatchingCardContent__VideoButton}
							title="Воспроизвести видео"
							onClick={showModalVideo}
						>
							<Icon
								icon="audio-playIcon"
								className={styles.MatchingCardContent__VideoButtonIcon}
							/>
						</button>
						{isModalOpened && (
							<Modal
								isShowModal={isModalOpened}
								onRequestClose={handleCloseModal}
								theme="video"
							>
								<StyledContentVideo
									autoPlay
									material={video}
									className={styles.MatchingCardContent__Video}
								/>
							</Modal>
						)}
					</div>
				)}
			</div>
		</div>
	);
};

MatchingCardContent.propTypes = {
	audio: MaterialPropType,
	image: PropTypes.oneOfType([ThumbnailFilePropType, PropTypes.string]),
	text: PropTypes.string,
	typeCard: PropTypes.oneOf(['drag', 'example']),
	video: MaterialPropType
};

export default MatchingCardContent;
